import { useMemo } from 'react'
import { Difficulty, difficultyToCssClass } from '@all-for-one/shared-types'
import styles from 'css/components/difficulty-tag.module.css'

/**
 * A student's level, as a pill in her tier colours.
 *
 * Was a local `DifficultyTag` inside question-results/page.tsx -- not
 * exported, so the two student pages would each have needed their own copy of
 * it plus a fourth and fifth copy of the three tier colours. The colours
 * already appear in difficulty-pills.module.css and question-slide.css;
 * duplicating them again is what this exists to prevent.
 *
 * Renders nothing when there is no level, rather than an empty pill: a lesson
 * taken before levels were assigned has no tier, and a blank chip reads as a
 * loading state.
 */
export const DifficultyTag = ({ difficulty }: { difficulty?: string }) => {
	const cssClass = useMemo(
		() => difficultyToCssClass[difficulty as Difficulty],
		[difficulty]
	)
	if (!difficulty || !cssClass) return null
	return <span className={styles[cssClass]}>{difficulty}</span>
}
